
  <section class="section py-1" *ngIf="isLoading">
    <app-spinner></app-spinner>
  </section>
  <section class="section pt-5 pb-0" *ngIf="!isLoading && !isTableView">
    <div class="columns">
      <div class="column is-5 pl-0">
        <div class="field">
          <label class="label">Buscar por orden, número de producto o descripción</label>
          <div class="control">
            <input class="input" type="text" placeholder="Buscar.." [(ngModel)]="filters.search.value"
              (keyup.enter)="onFilter()">
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Fecha inicio</label>
          <div class="control">
            <input class="input" type="date" placeholder="01/10/1990" [(ngModel)]="filters.dateInit.value"
              (ngModelChange)="onFilter()"   (ngModelChange)="onStartDateChange($event)" 
              >
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Last day</label>
          <div class="control">
            <input class="input" type="date" placeholder="01/10/1990" [(ngModel)]="filters.dateFin.value"
              (ngModelChange)="onFilter()">
          </div>
        </div>
      </div>
      <div class="column pr-0">
        <div class="field">
          <label class="label">Blender</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select [(ngModel)]="filters.blender.value" (ngModelChange)="onFilter()">
                <option value="">Escoge un blender</option>
                <option *ngFor="let blender of blenders" [value]="blender.description"> {{ blender.description }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column pr-0">
        <div class="field">
          <label class="label">Envasadora</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select [(ngModel)]="filters.packaging_machine.value" (ngModelChange)="onFilter()">
                <option value="">Escoge una envasadora</option>
                <option *ngFor="let packagingMachine of packagingMachines" [value]="packagingMachine.id"> {{ packagingMachine.description }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="section pt-5 pb-0" [ngStyle]="{'background-color':''}" *ngIf="!isLoading && isTableView">
    <div class="columns is-multiline">
      <div class="column is-2">
          <app-datepicker [isViewApo]="true" [selectedDate]="date" (dateChange)="onDateChange($event)"></app-datepicker>
      </div>
      <div class="column is-2">
          <span class="label">Blenders</span>
          <p-multiSelect 
              [options]="blendersForVS"
              optionLabel= "id"
              [(ngModel)]="selectedBlenders" 
              filter="false"
              placeholder="Seleccionar"
              showClear="true"
              (onClear)="selectedBlenders = []"
              showHeader="false">
              <ng-template let-blender pTemplate="item">
                  <div>Blender {{ blender.id }}</div>
              </ng-template>
          </p-multiSelect>
      </div>
      <div class="column is-2">
          <span class="label">Envasadoras</span>
          <p-multiSelect 
              [options]="packagingMachinesForVS"
              optionLabel="id"
              [(ngModel)]="selectedPackagingMachines"
              filter="false"
              placeholder="Seleccionar"
              showClear="true"
              (onClear)="selectedPackagingMachines = []"
              showHeader="false"
          /> 
      </div>
    </div>
  </section>

  <section class="section py-2">
    <div class="column is-12 switch-container">
      <div class="switch-right-group">
        <label class="switch-label">Tabla</label>
        <p-inputSwitch [(ngModel)]="isTableView"/>
        <label class="switch-label">Timeline</label>
        <div class="vs-switcher ml-4">
          <button class="button vs-btn" [class.vs-active]="selectedValueStream === ValueStream.VS1" (click)="selectedValueStream = ValueStream.VS1">VS1</button>
          <button class="button vs-btn" [class.vs-active]="selectedValueStream === ValueStream.VS2" (click)="selectedValueStream = ValueStream.VS2">VS2</button>
        </div>
      </div>
    </div>
  </section>
  <section class="section py-1" *ngIf="!isLoading && !isTableView">
    <div class="columns has-background-white">
      <div class="column">
        <div class="columns">
          <div class="column p-5">
            <div class="table-apo" *ngIf="apoFiltered">
              <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="apoFiltered"
                (onSelectRow)="openModal($event)" (onDeleteItem)="delete($event)"></app-generic-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="section py-1"*ngIf="!isLoading && isTableView" >
    <div class="columns" [ngStyle]="{'background-color':'white'}">
      <div class="column is-12">
        <app-timeline
      [blenderTasks]="filteredBlenderTasks"
      [packagingTasks]="filteredPackagingTasks"
      [blenders]="blendersForTimeline"
      [packagingMachines]="packagingMachinesForTimeline"
      [calendar]="calendar"
      [selectedDate]="date"
      [cameraHeatmapSegments]="cameraHeatmapSegments"
      [showCameraHeatmapRow]="true"
      [isViewApo]="true"
      (dateIncrement)="onDateIncrement($event)">
    </app-timeline>
      </div>
    </div>
  </section>
  <div class="modal" [ngClass]="{'is-active': isModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card" >
      <form [formGroup]="form" (ngSubmit)="onSave()" *ngIf="form.value.type === 'order'">
        <header class="modal-card-head">
          <p class="modal-card-title" >Orden: {{ form.value.id }}</p>
          <p class="modal-card-title" *ngIf="cleaningForm.value.type === 'limpieza'">Limpieza: {{ cleaningForm.value.name }}</p>
          <button type="button" class="delete" aria-label="close" (click)="closeModal()"></button>
        </header>
        <section class="modal-card-body" *ngIf="form.value.type === 'order'">
          <div class="columns">
            <div class="column is-6">
              <div class="notification is-danger" *ngIf="hasError">
                <button class="delete" (click)="closeNotification()"></button>
                Ha ocurrido un error al <span>editar</span> el
                producto
              </div>
              <div class="field"  formGroupName="product">
                <label class="label">Grad</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Nombre" formControlName="id">
                </div>
              </div>
              <div formGroupName="product">
                <div class="field">
                  <label class="label">Producto</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="Producto" formControlName="description">
                  </div>
                </div>
              </div>
              <div formGroupName="material">
                <div class="field">
                  <label class="label">Material</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="Material" formControlName="description">
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Last Day</label>
                <div class="control">
                  <input class="input" type="datetime-local"   [value]="form.get('fecha_inicio_preparacion')?.value | dateUtc" formControlName="last_day">
                </div>
              </div>
              <div class="field">
                <label class="label">Loss Percent</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Loss Percent" formControlName="loss_percent">
                </div>
              </div>
              <div class="field">
                <label class="label">Blender</label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="blender" [compareWith]="compareBlenders">
                      <option *ngFor="let blender of blenders" [ngValue]="blender">{{ blender.id }} - {{ blender.description }}
                      </option>
                    </select>
                  </div>  
                </div>
              </div>
              <div class="field">
                <label class="label">Fecha inicio Preparacion</label>
                <div class="control">
                  <input class="input" type="datetime-local"    placeholder="Fecha inicio preparacion" formControlName="fecha_inicio_preparacion">
                </div>
              </div>
              <div class="field">
                <label class="label">Fecha fin Preparacion</label>
                <div class="control">
                  <input class="input" type="datetime-local"   placeholder="Fecha fin preparacion" formControlName="fecha_fin_preparacion">
                </div>
              </div>
              <div class="field">
                <label class="label">Fecha inicio Blender</label>
                <div class="control">
                  <input class="input" type="datetime-local"   placeholder="Fecha inicio Blender" formControlName="fecha_inicio_blender">
                </div>
              </div>
              <div class="field">
                <label class="label">Fecha fin Blender</label>
                <div class="control">
                  <input class="input" type="datetime-local"   placeholder="Fecha fin Blender" formControlName="fecha_fin_blender">
                </div>
              </div>
              <div class="field">
                <label class="label">Fecha inicio Calidad</label>
                <div class="control">
                  <input class="input" type="datetime-local"  placeholder="Fecha inicio calidad" formControlName="fecha_inicio_calidad">
                </div>
              </div>
              <div class="field">
                <label class="label">Fecha fin Calidad</label>
                <div class="control">
                  <input class="input" type="datetime-local" placeholder="Fecha fin calidad" formControlName="fecha_fin_calidad">
                </div>
              </div>
              <div class="field">
                <label class="label">Naturaleza del Producto</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Naturaleza del Producto" formControlName="product_nature">
                </div>
              </div>
              <div class="field">
                <label class="label">Fecha carga</label>
                <div class="control">
                  <input class="input" type="datetime-local"  formControlName="fecha_carga">
                </div>
              </div>
              
            </div>
            <div class="column is-6">
              <div class="field">
                <label class="label">Peso</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Peso" formControlName="weight">
                </div>
              </div>
              <div class="field">
                <label class="label">Tiempo Producción</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Tiempo Prodcción" formControlName="production_time">
                </div>
              </div>
            
              <div class="field">
                <label class="label">Tiempo Calidad</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Tiempo Calidad" formControlName="quality_time">
                </div>
              </div>
            
              <div class="field">
                <label class="label">Tiempo Envasado</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Tiempo Envasado" formControlName="packaging_time">
                </div>
              </div>
            
              <div class="field">
                <label class="label">Tiempo Total</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Tiempo Total" formControlName="total_time">
                </div>
              </div>
              
              <div class="field">
                <label class="label">OEE Blender</label>
                <div class="control">
                  <input class="input" type="number" placeholder="OEE Blender" formControlName="oee_blender">
                </div>
              </div>
              <div class="field">
                <label class="label">OEE Calidad</label>
                <div class="control">
                  <input class="input" type="number" placeholder="OEE Calidad" formControlName="oee_calidad">
                </div>
              </div>
              <hr>
              <div formArrayName="envasadora_orders">
                <label class="is-size-5 has-text-weight-bold"> Ordenes de envasado</label>
                @for(item of envasadoraOrders.controls; let i = $index; track item) {
                  <div [formGroupName]="i" class="">
                    <div class="field">
                      <label class="label">Envasadora</label>
                      <div class="control">
                        <div class="select is-fullwidth">
                          <select formControlName="packaging_machine" [compareWith]="compareBlenders">
                            <option *ngFor="let p of packagingMachines" [ngValue]="p">{{ p.id }} - {{ p.description }}
                            </option>
                          </select>
                        </div>  
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Fecha inicio Envasadora</label>
                      <div class="control">
                        <input class="input" type="datetime-local"  placeholder="Fecha inicio Envasadora" formControlName="fecha_inicio_envasadora">
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Fecha fin Envasadora</label>
                      <div class="control">
                        <input class="input" type="datetime-local" placeholder="Fecha fin Envasadora" formControlName="fecha_fin_envasadora">
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">OEE envasadora</label>
                      <div class="control">
                        <input class="input" type="text" placeholder="Fecha fin Envasadora" formControlName="oee_envasadora">
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Número de envases</label>
                      <div class="control">
                        <input class="input" type="text" placeholder="Fecha fin Envasadora" formControlName="packaging_quantity">
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Tiempo de envasado</label>
                      <div class="control">
                        <input class="input" type="text" placeholder="Fecha fin Envasadora" formControlName="packaging_time">
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">Tipo Demanda</label>
                      <div class="control">
                        <input class="input" type="text" placeholder="Tipo Demanda" formControlName="demand_type">
                      </div>
                    </div>
                  </div>
                  <hr>
                }

              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
          <button type="button" class="button" (click)="closeModal()" >Cancelar</button>
          <button type="submit" class="button is-primary"  *ngIf="form.value.type === 'order'" [disabled]="!form.valid">
            <span *ngIf="!isLoading">Guardar</span>
            <fa-icon [icon]="faSpinner" *ngIf="isLoading" [animation]="'spin'"></fa-icon>
          </button>
        </footer>
      </form>
      <form [formGroup]="cleaningForm" (ngSubmit)="onSave()" *ngIf="cleaningForm.value.type === 'limpieza'">
        <header class="modal-card-head">
          <p class="modal-card-title">Limpieza: {{ cleaningForm.value.name }}</p>
          <button type="button" class="delete" aria-label="close" (click)="closeModal()"></button>
        </header>
        <section class="modal-card-body" *ngIf="cleaningForm.value.type === 'limpieza'">
          <div class="columns">
            <div class="column">
              <div class="notification is-danger" *ngIf="hasError">
                <button class="delete" (click)="closeNotification()"></button>
                Ha ocurrido un error al <span>editar</span> la
                limpieza
              </div>
              <div class="field">
                <label class="label">Fecha inicio</label>
                <div class="control">
                  <input class="input" type="datetime-local"  placeholder="Fecha inicio" formControlName="fecha_inicio_blender">
                </div>
              </div>
              <div class="field">
                <label class="label">Fecha fin</label>
                <div class="control">
                  <input class="input" type="datetime-local"  placeholder="Fecha fin" formControlName="fecha_fin_blender">
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
          <button type="button" class="button" (click)="closeModal()">Cancelar</button>
          <button type="submit" class="button is-primary" [disabled]="!cleaningForm.valid" *ngIf="cleaningForm.value.type === 'limpieza'">
            <span *ngIf="!isLoading">Guardar</span>
            <fa-icon [icon]="faSpinner" *ngIf="isLoading" [animation]="'spin'"></fa-icon>
          </button>
        </footer>
      </form>
    </div>
  </div>
  <div class="modal" [ngClass]="{'is-active': isModalDeleteConfirm }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head modal-card-head-delete">
        <p class="modal-card-title">Confirmar eliminar</p>
        <button type="button" class="delete" aria-label="close" (click)="isModalDeleteConfirm = false"></button>
      </header>
      <section class="modal-card-body modal-card-body-delete">
        <div class="columns">
          <div class="column">
            <p class="message-confirm-delete">¿Estás seguro/a que deseas continuar?</p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-space-between">
        <button type="button" class="button" (click)="isModalDeleteConfirm = false">Cancelar</button>
        <button type="submit" class="button is-danger" (click)="deleteAllOrders()">Eliminar</button>
      </footer>
    </div>
  </div>